// src/contexts/ModalsContext.jsx
import { createContext, useContext } from 'react';
import { useModals } from '@/hooks/useModals';

const ModalsContext = createContext();

export function ModalsProvider({ children }) {
  const modalControls = useModals();
  
  return (
    <ModalsContext.Provider value={modalControls}>
      {children}
    </ModalsContext.Provider>
  );
}

export function useModalsContext() {
  const context = useContext(ModalsContext);
  if (!context) {
    throw new Error('useModalsContext must be used within a ModalsProvider');
  }
  return context;
}